/**
 * "Data export and erasure" — Guides section (B27.3, 2026-06-12).
 *
 * Written STRICTLY against what ships today (the C26 pairing rule: never
 * ahead of it): the DSAR intake (form + email; five request types under
 * GDPR Art. 15–22; immediate acknowledgment with reference + expected
 * date) and the published windows (24h ack / 30-day fulfilment), plus the
 * MSA offboarding-export right. This is deliberately a PROCESS guide —
 * it does not describe fulfillment mechanics (self-serve export downloads,
 * automated retention purges): those are C26's surface and the guide gains
 * them when C26 ships, not before.
 */
import type { DocPageContent } from '../types';

export const GUIDES_DATA_EXPORT_ERASURE_PAGE: DocPageContent = {
  slug: 'guides/data-export-erasure',
  titleKey: 'docs.guides.dsar.title',
  descriptionKey: 'docs.guides.dsar.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.guides.dsar.lead' },

    { kind: 'heading', level: 2, id: 'requests', textKey: 'docs.guides.dsar.requests.heading' },
    { kind: 'paragraph', textKey: 'docs.guides.dsar.requests.body' },

    { kind: 'heading', level: 2, id: 'windows', textKey: 'docs.guides.dsar.windows.heading' },
    { kind: 'paragraph', textKey: 'docs.guides.dsar.windows.body' },

    { kind: 'heading', level: 2, id: 'split', textKey: 'docs.guides.dsar.split.heading' },
    { kind: 'paragraph', textKey: 'docs.guides.dsar.split.body' },

    {
      kind: 'heading',
      level: 2,
      id: 'offboarding',
      textKey: 'docs.guides.dsar.offboarding.heading',
    },
    { kind: 'paragraph', textKey: 'docs.guides.dsar.offboarding.body' },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.guides.dsar.related.privacy.title',
          textKey: 'docs.guides.dsar.related.privacy.text',
          to: { docSlug: 'trust/privacy' },
        },
        {
          titleKey: 'docs.guides.dsar.related.production.title',
          textKey: 'docs.guides.dsar.related.production.text',
          to: { docSlug: 'guides/go-to-production' },
        },
      ],
    },
  ],
};
